<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100"
    height="100"
    viewBox="0 0 100 100"
    class="heroicon-target heroicon heroicons-lg"
  >
    <path
      class="heroicon-target-background heroicon-component-fill"
      fill="#FFFFFF"
      d="M82 11.58V18h6.42A50 50 0 1 1 82 11.58z"
    ></path>
    <path
      class="heroicon-target-stripes heroicon-component-accent heroicon-component-fill"
      fill="#7ACFC0"
      d="M82 11.58V18h6.42A50 50 0 1 1 82 11.58zM50 90a40 40 0 1 0 0-80 40 40 0 0 0 0 80zm0-10a30 30 0 1 1 0-60 30 30 0 0 1 0 60zm0-10a20 20 0 1 0 0-40 20 20 0 0 0 0 40zm0-10a10 10 0 1 1 0-20 10 10 0 0 1 0 20z"
    ></path>
    <polygon
      class="heroicon-target-arrow heroicon-component-fill"
      fill="#FFFFFF"
      points="82 10 92 0 92 8 100 8 90 18 82 18"
    ></polygon>
    <rect
      class="heroicon-shadows"
      width="49"
      height="2"
      x="50"
      y="49"
      fill="#000000"
      opacity=".2"
    ></rect>
    <path
      class="heroicon-outline"
      fill="#4A4A4A"
      fill-rule="nonzero"
      d="M92 0v8h8L90 18h-1.58A50 50 0 1 1 82 11.58V10L92 0zm-3 50a38.87 38.87 0 0 0-10.72-26.86L71.9 29.5a30 30 0 1 1-1.41-1.41l6.36-6.38A39 39 0 1 0 89 50zm-5.59-32l-4.43 4.43a40 40 0 1 1-1.41-1.41L82 16.59v-2.37A48 48 0 1 0 85.78 18H83.4zM69.8 28.8a29 29 0 1 0 1.41 1.41l-6.37 6.37a20 20 0 1 1-1.41-1.41l6.37-6.37zm-7.08 7.08a19 19 0 1 0 1.41 1.41l-6.38 6.38a10 10 0 1 1-1.41-1.41l6.38-6.38zm-7.1 7.09a9 9 0 1 0 1.41 1.41l-6.31 6.33a1 1 0 1 1-1.42-1.42l6.33-6.32zM84 15.29l6-6V4.83l-6 6v4.46zm.7.71h4.47l6-6h-4.46l-6 6z"
    ></path>
  </svg>
</template>
